const ABN_LENGTH = 11;

export const validateABN = (abn: string): boolean => {
  if (!Number(abn) || abn.length !== ABN_LENGTH) return false;

  const weights = [10, 1, 3, 5, 7, 9, 11, 13, 15, 17, 19];
  let weightedSum = 0;

  for (let i = 0; i < weights.length; i += 1) {
    weightedSum += (parseInt(abn[i], 10) - (i === 0 ? 1 : 0)) * weights[i];
  }

  return weightedSum % 89 === 0;
};
